import { RenderingType } from '@vonage/ml-transformers';
import envDefault from '../../../helpers/env';
import getCdnUrl from '../../../helpers/getCdnUrl';

// Default configuration for @vonage/ml-transformers library
const getDefaultConfig = (deps = {}) => {
  const {
    proxyUrl,
    env = envDefault,
    ...libraryOverrideOptions
  } = deps;

  const cdnHost = getCdnUrl({ env, proxyUrl });
  const config = {
    modelAssetUriPath: `${cdnHost}/ml-transformers/v6.0.0/float16/vonage_selfie_segmenter.tflite`,
    mediapipeBaseAssetsUri: `${cdnHost}/ml-transformers/v6.0.0/mediapipe/0.10.20`,
    renderingOptions: { type: RenderingType.CANVAS },
    ...libraryOverrideOptions,
  };

  if (env.isMobileDevice) {
    config.segmentationOptions = {
      lightWeightEngine: true,
    };
    config.modelAssetUriPath = `${cdnHost}/ml-transformers/v4.0.0/selfie_segmentation_landscape.tflite`;
    config.mediapipeBaseAssetsUri = `${cdnHost}/ml-transformers/v4.0.0/`;
  }

  return config;
};

export default getDefaultConfig;
